module.exports = __webpack_public_path__ + "src/assets/et.4380ce70.png";